import React from 'react';

import styles from './toast.scss';

interface Props {
  children: any;
  className?: string;
}

const ErrorToast: React.FC<Props> = ({ children, className }) => {
  return <div className={`${styles.container} ${className || ''}`}>{children}</div>;
};

export default ErrorToast;
